// components/TooltipInfoBox.js
import React from "react";
import "../Style/TooltipInfoBox.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export default function TooltipInfoBox() {
  return (
    <div className="tooltip-container">
      <span className="info-icon">
        {" "}
        <FontAwesomeIcon icon={faCircleInfo} />
      </span>
      <div className="tooltip-text">
        <strong style={{ color: "#28a745" }}>Green:</strong> Customer is
        credited
        <br />
        <strong style={{ color: "#dc3545" }}>Red:</strong> Costumer is debited
      </div>
    </div>
  );
}
